import { TableColumn } from "./dataInterface";

export const incentiveTableColumn: TableColumn = {
  title: "インセンティブ一覧",
  detail: true,
  detailTitle: "インセンティブ詳細",
  detailColumn: "詳細",
  detailKey: ["id"],
  addTitle: "インセンティブ登録",
  editAuth: ["マスターアカウント", "スタッフアカウント"],
  tableFunction: [],
  postCSVTitle: "インセンティブCSV取込",
  dataColumn: [
    {
      key: "high_rank_company_name",
      name: "上位店名",
      tableDetailAuth: ["マスターアカウント", "スタッフアカウント"],
      table: true,
      tableMinWidth: "150px",
      sort: false,
      tableValue: "text",
      serch: true,
      serchType: "high_rank_company",
      detail: true,
      edit: false,
      editType: null,
      editId: "high_rank_company_id",
      add: false,
      addType: null,
      addMessage: "",
    },
    {
      key: "high_rank_company_id",
      name: "上位店名",
      tableDetailAuth: ["マスターアカウント", "スタッフアカウント"],
      table: false,
      tableMinWidth: "",
      sort: false,
      tableValue: "text",
      serch: false,
      serchType: null,
      detail: false,
      edit: false,
      editType: null,
      editId: "id",
      add: true,
      addType: "high_rank_company",
      addMessage: "",
    },
    {
      key: "product_name",
      name: "商材名",
      tableDetailAuth: ["マスターアカウント", "スタッフアカウント"],
      table: true,
      tableMinWidth: "150px",
      sort: false,
      tableValue: "text",
      serch: true,
      serchType: "product",
      detail: true,
      edit: false,
      editType: null,
      editId: "product_id",
      add: false,
      addType: null,
      addMessage: "",
    },
    {
      key: "product_id",
      name: "商材名",
      tableDetailAuth: ["マスターアカウント", "スタッフアカウント"],
      table: false,
      tableMinWidth: "",
      sort: false,
      tableValue: "text",
      serch: false,
      serchType: null,
      detail: false,
      edit: false,
      editType: null,
      editId: "id",
      add: true,
      addType: "product",
      addMessage: "",
    },
    {
      key: "incentive_status_conf",
      name: "取次ステータスの指定",
      tableDetailAuth: ["マスターアカウント", "スタッフアカウント"],
      table: true,
      tableMinWidth: "150px",
      sort: false,
      tableValue: "text",
      serch: true,
      serchType: "list",
      editType: "list",
      detail: true,
      edit: true,
      editId: "id",
      add: true,
      addType: "list",
      addMessage: "",
    },
    {
      key: "incentive_status",
      name: "取次ステータス",
      tableDetailAuth: ["マスターアカウント", "スタッフアカウント"],
      table: true,
      tableMinWidth: "150px",
      sort: false,
      tableValue: "text",
      serch: true,
      serchType: "bubun",
      detail: true,
      edit: true,
      editType: "text",
      editId: "id",
      add: true,
      addType: "text",
      addMessage: "",
    },
    {
      key: "service_name",
      name: "サービス名",
      tableDetailAuth: ["マスターアカウント", "スタッフアカウント"],
      table: false,
      tableMinWidth: "",
      sort: false,
      tableValue: "text",
      serch: true,
      serchType: "bubun",
      detail: false,
      edit: false,
      editType: null,
      editId: "",
      add: false,
      addType: null,
      addMessage: "",
    },
    {
      key: "deposit_start_date",
      name: "条件適応期間",
      tableDetailAuth: ["マスターアカウント", "スタッフアカウント"],
      table: false,
      tableMinWidth: "",
      sort: false,
      tableValue: "text",
      serch: true,
      serchType: "date",
      detail: false,
      edit: false,
      editType: null,
      editId: "",
      add: false,
      addType: null,
      addMessage: "",
    },
    {
      key: "entry_sale_company_name",
      name: "エントリーパートナー",
      tableDetailAuth: ["マスターアカウント", "スタッフアカウント"],
      table: false,
      tableMinWidth: "",
      sort: false,
      tableValue: "text",
      serch: true,
      serchType: "company",
      detail: false,
      edit: false,
      editType: null,
      editId: "",
      add: false,
      addType: null,
      addMessage: "",
    },
  ],
  subTable: [
    {
      subTableAuth: ["マスターアカウント", "スタッフアカウント"],
      mainTableDetail: false,
      mainTableDetailColumn: "",
      subTableColumnName: "サービス一覧",
      subTableColumnLength: "service_length",
      subTableColumnNameWidth: "85px",
      detailKey: ["id"],
      subTableDetail: false,
      subTableDetailTitle: "サービス詳細",
      subTableAdd: true,
      subTableAddTitle: "サービス追加",
      subTableAddTitleWidth: "85px",
      subTableEdit: false,
      subTableEditTitle: "サービス編集",
      subTableEditDirect: false,
      subTableEditDirectKey: "",
      subTableEditAuth: ["マスターアカウント", "スタッフアカウント"],
      tableFunction: [],
      subDataColumn: [
        {
          key: "service_name",
          name: "サービス名",
          table: true,
          tableValue: "text",
          detail: false,
          edit: false,
          editType: null,
          editId: "id",
          add: true,
          addType: "incentive_service",
          addMessage: "",
        },
      ],
      subTable: [],
    },
    {
      subTableAuth: ["マスターアカウント", "スタッフアカウント"],
      mainTableDetail: false,
      mainTableDetailColumn: "",
      subTableColumnName: "入金単価一覧",
      subTableColumnLength: "deposit_length",
      subTableColumnNameWidth: "85px",
      detailKey: ["id"],
      subTableDetail: true,
      subTableDetailTitle: "上位店入金単価詳細",
      subTableAdd: true,
      subTableAddTitle: "入金単価追加",
      subTableAddTitleWidth: "85px",
      subTableEdit: true,
      subTableEditTitle: "上位店入金単価編集",
      subTableEditDirect: false,
      subTableEditDirectKey: "",
      subTableEditAuth: ["マスターアカウント", "スタッフアカウント"],
      tableFunction: [
        {
          name: "削除",
          auth: ["マスターアカウント", "スタッフアカウント"],
        },
      ],
      subDataColumn: [
        {
          key: "high_rank_company_name",
          name: "上位店名",
          table: false,
          tableValue: "text",
          detail: true,
          edit: false,
          editType: null,
          editId: "high_rank_company_id",
          add: true,
          addType: "tableData",
          addMessage: "",
        },
        {
          key: "product_name",
          name: "商材名",
          table: false,
          tableValue: "text",
          detail: true,
          edit: false,
          editType: null,
          editId: "product_id",
          add: true,
          addType: "tableData",
          addMessage: "",
        },
        {
          key: "incentive_id",
          name: "インセンティブ",
          table: false,
          tableValue: "text",
          detail: false,
          edit: false,
          editType: null,
          editId: "service_id",
          add: true,
          addType: "tableId",
          addMessage: "",
        },
        {
          key: "deposit_start_date",
          name: "条件適応期間 - 開始",
          table: true,
          tableValue: "text",
          detail: true,
          edit: true,
          editType: "date",
          editId: "id",
          add: true,
          addType: "date",
          addMessage: "",
        },
        {
          key: "incentive_number",
          name: "取次数（～以上）",
          table: true,
          tableValue: "text",
          detail: true,
          edit: true,
          editType: "text",
          editId: "id",
          add: true,
          addType: "text",
          addMessage: "",
        },
        {
          key: "deposit_value",
          name: "上位店入金単価",
          table: true,
          tableValue: "text",
          detail: true,
          edit: true,
          editType: "text",
          editId: "id",
          add: true,
          addType: "text",
          addMessage: "",
        },
      ],
      subTable: [],
    },
    {
      subTableAuth: ["マスターアカウント", "スタッフアカウント"],
      mainTableDetail: false,
      mainTableDetailColumn: "",
      subTableColumnName: "パートナー一覧",
      subTableColumnLength: "entry_length",
      detailKey: ["id", "payment_method_id"],
      subTableColumnNameWidth: "100px",
      subTableDetail: true,
      subTableDetailTitle: "パートナー支払単価詳細",
      subTableAdd: true,
      subTableAddTitle: "パートナー追加",
      subTableAddTitleWidth: "100px",
      subTableEdit: true,
      subTableEditTitle: "パートナー支払単価編集",
      subTableEditDirect: false,
      subTableEditDirectKey: "",
      subTableEditAuth: ["マスターアカウント", "スタッフアカウント"],
      tableFunction: [
        {
          name: "削除",
          auth: ["マスターアカウント", "スタッフアカウント"],
        },
      ],
      subDataColumn: [
        {
          key: "high_rank_company_name",
          name: "上位店名",
          table: false,
          tableValue: "text",
          detail: true,
          edit: false,
          editType: null,
          editId: "high_rank_company_id",
          add: true,
          addType: "tableData",
          addMessage: "",
        },
        {
          key: "product_name",
          name: "商材名",
          table: false,
          tableValue: "text",
          detail: true,
          edit: false,
          editType: null,
          editId: "product_id",
          add: true,
          addType: "tableData",
          addMessage: "",
        },
        {
          key: "incentive_id",
          name: "インセンティブID",
          table: false,
          tableValue: "text",
          detail: false,
          edit: false,
          editType: null,
          editId: "incentive_id",
          add: true,
          addType: "tableId",
          addMessage: "",
        },
        {
          key: "entry_sale_company_id",
          name: "エントリーパートナー",
          table: false,
          tableValue: "text",
          detail: false,
          edit: false,
          editType: null,
          editId: "incentive_sale_company_config_id",
          add: true,
          addType: "company",
          addMessage: "",
        },
        {
          key: "entry_sale_company_name",
          name: "エントリーパートナー",
          table: true,
          tableValue: "text",
          detail: true,
          edit: false,
          editType: null,
          editId: "incentive_sale_company_config_id",
          add: false,
          addType: null,
          addMessage: "",
        },
        {
          key: "payment_start_date",
          name: "条件適応期間 - 開始",
          table: false,
          tableValue: "text",
          detail: true,
          edit: true,
          editType: "date",
          editId: "incentive_sale_company_config_id",
          add: true,
          addType: "date",
          addMessage: "",
        },
        {
          key: "payment_end_date",
          name: "条件適応期間 - 終了",
          table: false,
          tableValue: "text",
          detail: true,
          edit: true,
          editType: "date",
          editId: "incentive_sale_company_config_id",
          add: true,
          addType: "date",
          addMessage: "",
        },
        {
          key: "payment_start_end_date",
          name: "条件適応期間",
          table: true,
          tableValue: "text",
          detail: false,
          edit: false,
          editType: null,
          editId: "incentive_sale_company_config_id",
          add: false,
          addType: null,
          addMessage: "",
        },
        {
          key: "incentive_number",
          name: "取次数（～以上）",
          table: true,
          tableValue: "text",
          detail: true,
          edit: true,
          editType: "text",
          editId: "id",
          add: true,
          addType: "text",
          addMessage: "",
        },
        {
          key: "payment_value",
          name: "パートナー支払単価",
          table: true,
          tableValue: "text",
          detail: true,
          edit: true,
          editType: "text",
          editId: "id",
          add: true,
          addType: "text",
          addMessage: "",
        },
      ],
      subTable: [],
    },
  ],
};
